export const mapIsSelected = (event, activeEventId) => {
    event.isSelected = event.id === activeEventId;
    return event;
};
//# sourceMappingURL=mapIsSelected.js.map